import BlogDetailsSection2 from './BlogDetailsSection2' ;
import BlogDetailsBanner2 from './BlogDetailsBanner2' ;

function BlogDetails2() {
  return (
    <div>
      <BlogDetailsBanner2 />
      <BlogDetailsSection2 />
    </div>
  );
}

export default BlogDetails2;